// Librairies.
import { HttpClient } from '@/shared/HttpClient';
import { AxiosPromise } from 'axios';

// Services.
import { ApiService } from '@/services/base/ApiService';

// Modeèles.
import { UtilisateurProducteur } from '@/components/administration/utilisateurs/models/UtilisateurProducteur.model';
import { Result } from '@/shared/models/Result.model';
import { Message } from '@/shared/models/Message.model';
import UserApplication from '@engie-ec/app-launcher-okta-b2b/types/models/UserApplication';

export default class UtilisateurProducteurService extends ApiService<UtilisateurProducteur> {
    /**
     * Constructeur.
     */
    constructor() {
        super('UtilisateurProducteur');
    }

    public signerCgu(): AxiosPromise<Result<Message>> {
        return HttpClient.axios.get<Result<Message>>(`${this.endpoint}/SignerCgu`, this.setupAnnulationEtGetConfig());
    }

    /**
     * Appel l'api pour mettre à jour la signature du template POS
     * @returns 
     */
    public signerTemplatePos(): AxiosPromise<Result<Message>> {
        return HttpClient.axios.get<Result<Message>>(`${this.endpoint}/SignerTemplatePOs`, this.setupAnnulationEtGetConfig());
    }

    /**
     * Appelle l'API pour récupérer les applications OKTA de l'utilisateur.
     */
    public getListApplicationOkta(): AxiosPromise<Result<Array<UserApplication>>> {
        return HttpClient.axios.get<Result<Array<UserApplication>>>(`${this.endpoint}/ApplicationsOkta`, this.setupAnnulationEtGetConfig());
    }
}
